import { Check, Prohibit } from "@phosphor-icons/react";

import { FilterTag, FilterTagChild } from "features/filters/components";

import CompanyImage from "common/components/ui/CompanyImage";
import ProfileImage from "common/components/ui/ProfileImage";

export default function SelectionTags<
  OptionType extends Record<string, string> & {
    id: string;
  },
>({
  selection,
  labelKey,
  onRemoveFilter,
  onFlipFilter = null,
}: {
  selection: OptionType[];
  labelKey: keyof OptionType;
  onRemoveFilter: (option: OptionType) => void;
  onFlipFilter?: (option: OptionType) => void;
}) {
  const isExcludeIncludeSelection = !!onFlipFilter;
  return (
    <div className="mt-1.5 flex flex-wrap gap-1.5 px-2">
      {selection.map((option) => {
        const { id, logoUrl } = option;

        const isIncluded =
          option.selectionType === "INCLUDED" || !isExcludeIncludeSelection;

        const ImageComponent = id.startsWith("urn:li:organization:")
          ? CompanyImage
          : ProfileImage;

        return (
          <FilterTag
            variant={isIncluded ? "default" : "danger"}
            key={id}
            onRemove={() => onRemoveFilter(option)}
          >
            <FilterTagChild>
              {logoUrl && <ImageComponent size="3xs" src={logoUrl} />}
              {option[labelKey]}
            </FilterTagChild>
            {isExcludeIncludeSelection && (
              <FilterTagChild
                onClick={() => {
                  onFlipFilter(option);
                }}
              >
                {isIncluded ? <Prohibit /> : <Check />}
              </FilterTagChild>
            )}
          </FilterTag>
        );
      })}
    </div>
  );
}
